import { SlideComponentImage } from '@/types/slide';
import { SlideComponentCreator } from './factory';

export class SlideComponentImageCreator extends SlideComponentCreator {
    public create(id: string): SlideComponentImage {
        return {
            id: id,
            type: 'image',
            pos: {
                x: 0,
                y: 0,
            },
            size: { width: 200, height: 200 },
            content: {
                image: '',
                imageURL: '',
                flip: 1,
            },
        };
    }
}
